export enum PaginationBarColor {
  Primary = "primary",
}
